module.exports = __webpack_public_path__ + "static/media/Protrusion of the anterior teeth8.82af1937.png";